import { gql, useMutation } from '@apollo/client';

export const CREATE_OR_UPDATE_PO_SALE_ORDER_MUTATION = gql`
  mutation CreateOrUpdatePoSaleOrder($data: PoSaleOrderInput!) {
    poSaleOrder {
      createOrUpdatePoSaleOrder(data: $data) {
        success
        message {
          code
          message
        }
        content {
          id
          cd
          orderDate
          orderType
          sellType
          total
          orderTotal
          orderTotalAfterTax
          vat
          orderStatus
          orderSource
          description
          referencePo
          deliveryAddress
          receiver
          customer {
            id
            cd
            name
          }
          distributor {
            id
            cd
            name
          }
          salesman {
            cd
            name
          }
          orderItems {
            id
            qty
            unitId
            unitPrice
            product {
              id
              cd
              name
              barcode
              otherReference
            }
            warehouse {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export interface PoSaleOrderItemInput {
  id: number;
  warehouseId: number;
  productId: number;
  unitId: string;
  unitPrice: number;
  qty: number;
  sortOrder?: number;
  isFreeItem?: boolean;
}

export interface PoSaleOrderInput {
  id: number;
  cd?: string;
  orderDate: string;
  orderType: string;
  sellType?: string;
  description?: string;
  externalReference?: string;
  referencePo?: string;
  distributorId: number;
  customerId: number;
  salesmanId?: number | null;
  salesSupervisorId?: number | null;
  asmId?: number | null;
  directorId?: number | null;
  mcpId?: number | null;
  commandoId?: number | null;
  checkInId?: number | null;
  checkInCommandoId?: number | null;
  deliveryAddress?: string;
  receiver?: string;
  isDistance: boolean;
  nguoiDatHang?: string;
  ngayYeuCauGiaoHang?: string;
  ngayDatHang?: string;
  orderItems: PoSaleOrderItemInput[];
}

export const useCreateOrUpdatePoSaleOrderMutation = () => {
  return useMutation(CREATE_OR_UPDATE_PO_SALE_ORDER_MUTATION);
};

